import React from 'react';

import './Homepage.scss';
import AboutMe from '../../components/AboutMe';
import Companies from '../../components/Companies';
import TechStack from '../../components/TechStack';
import TechnicalPosts from '../../components/TechnicalPosts';
import Services from '../../components/Services';
import Testimony from '../../components/Testimony';
import Contact from '../../components/Contact';
import Footer from '../../components/Footer';

const Homepage = () => {
  return (
    <div className='container'>
        <AboutMe />
        <div className="gray-bg">
            <Companies />
            <TechStack />
        </div>
        <TechnicalPosts />
        <Services />
        <div className="gray-bg">
            <Testimony />
        </div>
        <Contact />
        <Footer />
    </div>
  )
}

export default Homepage